/* Coffee Roast Lab product page: option tiles, variant + selling plan sync, gallery, sticky bar, bundle progress. */
(function () {
  if (window.__crlPdp) return;
  window.__crlPdp = true;

  function money(cents) {
    var d = cents / 100;
    return '$' + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function init(root) {
    var dataEl = document.querySelector('[data-crl-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('#crl-product-form');
    var idInput = root.querySelector('[data-crl-variant-input]');
    var planInput = root.querySelector('[data-crl-plan-input]');
    var qtyInput = root.querySelector('[data-crl-qty-input]');
    var atc = root.querySelector('[data-crl-atc]');
    var atcText = root.querySelector('[data-crl-atc-text]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-crl-opt]'));
    var plansWrap = root.querySelector('[data-crl-plans]');
    var freqWrap = root.querySelector('[data-crl-freq]');
    var freqBtns = freqWrap ? Array.prototype.slice.call(freqWrap.querySelectorAll('[data-plan-id]')) : [];
    var sticky = document.querySelector('[data-crl-sticky]');

    var state = {
      selected: [],
      sub: plansWrap ? plansWrap.querySelector('[data-crl-plan="sub"]').getAttribute('aria-pressed') === 'true' : false,
      plan: null
    };
    var current = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];
    state.selected = current.options.slice();

    // Default frequency: 2 weeks if offered, else the first plan.
    if (freqBtns.length) {
      var def = freqBtns.filter(function (b) { return /^2 /.test(b.getAttribute('data-label')); })[0] || freqBtns[0];
      state.plan = def.getAttribute('data-plan-id');
    }

    function findVariant(sel) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }

    function render() {
      var v = findVariant(state.selected);
      // Option tiles: pressed state, availability, current labels.
      opts.forEach(function (fs) {
        var oi = parseInt(fs.getAttribute('data-crl-opt'), 10);
        var cur = fs.querySelector('[data-crl-current]');
        fs.querySelectorAll('[data-value]').forEach(function (b) {
          var val = b.getAttribute('data-value');
          var on = val === state.selected[oi];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var test = state.selected.slice();
          test[oi] = val;
          var tv = findVariant(test);
          b.classList.toggle('is-unavailable', !tv || !tv.available);
          if (on && cur) cur.textContent = b.getAttribute('data-short') + (fs.classList.contains('crl-opt--size') ? ' · ' + money(tv ? tv.price : 0) : '');
        });
        var help = fs.querySelector('[data-crl-roast-help]');
        if (help) {
          var key = (state.selected[oi] || '').toLowerCase();
          help.textContent = data.roastHelp[key] || '';
        }
      });

      if (!v) {
        atc.disabled = true;
        atcText.textContent = 'Unavailable';
        return;
      }
      current = v;
      idInput.value = v.id;

      var once = v.price;
      var hasPlans = Object.keys(v.plans || {}).length > 0;
      var subPrice = state.plan && v.plans[state.plan] != null ? v.plans[state.plan] : null;
      var useSub = state.sub && hasPlans && subPrice != null;
      var unit = useSub ? subPrice : once;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

      planInput.disabled = !useSub;
      planInput.value = useSub ? state.plan : '';

      setText('[data-crl-price]', money(unit));
      setText('[data-crl-price-m]', money(unit));
      var was = root.querySelector('[data-crl-was]');
      if (was) { was.hidden = !useSub; was.textContent = money(once); }
      setText('[data-crl-once-price]', money(once));
      setText('[data-crl-sub-price]', hasPlans && subPrice != null ? money(subPrice) : 'Not available');
      var subNote = root.querySelector('[data-crl-sub-note]');
      if (subNote) {
        var pb = freqBtns.filter(function (b) { return b.getAttribute('data-plan-id') === state.plan; })[0];
        subNote.textContent = hasPlans && pb ? 'Every ' + pb.getAttribute('data-label') + ' · save ' + pb.getAttribute('data-pct') + '%' : '';
        subNote.hidden = !subNote.textContent;
      }

      if (plansWrap) {
        var subBtn = plansWrap.querySelector('[data-crl-plan="sub"]');
        plansWrap.querySelector('[data-crl-plan="once"]').setAttribute('aria-pressed', useSub ? 'false' : 'true');
        subBtn.setAttribute('aria-pressed', useSub ? 'true' : 'false');
        subBtn.disabled = !hasPlans;
        var na = root.querySelector('[data-crl-sub-na]');
        if (na) na.hidden = hasPlans;
      }
      if (freqWrap) {
        freqWrap.hidden = !useSub;
        freqBtns.forEach(function (b) {
          var on = b.getAttribute('data-plan-id') === state.plan;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) {
            var note = freqWrap.querySelector('[data-crl-freq-note]');
            if (note) note.textContent = 'Recurring order every ' + b.getAttribute('data-label') + ', ' + b.getAttribute('data-pct') + '% off. Skip or cancel anytime.';
          }
        });
      }

      atc.disabled = !v.available;
      atcText.textContent = v.available ? 'Add to cart · ' + money(unit * qty) : 'Sold out';

      // Main photo follows the selected variant.
      if (v.image) {
        var img = root.querySelector('[data-crl-main-img]');
        if (img && img.getAttribute('data-src-current') !== v.image) {
          img.removeAttribute('srcset');
          img.src = v.image;
          img.setAttribute('data-src-current', v.image);
        }
        var th = root.querySelector('[data-crl-thumb-variant]');
        if (th && v.thumb) { th.removeAttribute('srcset'); th.src = v.thumb; }
        var si = document.querySelector('[data-crl-sticky-img]');
        if (si && v.thumb) { si.removeAttribute('srcset'); si.src = v.thumb; }
      }

      // Sticky bar summary.
      var labels = opts.map(function (fs) {
        var b = fs.querySelector('.is-on');
        return b ? b.getAttribute('data-short') : '';
      }).filter(Boolean);
      var ss = document.querySelector('[data-crl-sticky-sel]');
      if (ss) ss.textContent = labels.join(' · ') + (useSub ? ' · Subscription' : '');
      var sp = document.querySelector('[data-crl-sticky-price]');
      if (sp) sp.textContent = money(unit);
      var sbp = document.querySelector('[data-crl-sticky-btnp]');
      if (sbp) sbp.textContent = v.available ? ' · ' + money(unit * qty) : '';
      var sb = document.querySelector('[data-crl-sticky-btn]');
      if (sb) sb.disabled = !v.available;

      // "Your pick" chip on the bag photo, since one photo is shared across sizes and grinds.
      var pick = root.querySelector('[data-crl-pick]');
      if (pick) {
        var pl = opts.filter(function (fs) { return !fs.classList.contains('crl-opt--roast'); }).map(function (fs) {
          var b = fs.querySelector('.is-on');
          return b ? b.getAttribute('data-short') : '';
        }).filter(Boolean);
        pick.textContent = pl.length ? 'Your pick: ' + pl.join(' · ') : '';
        pick.hidden = !pl.length;
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
    }

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-value]');
      if (tile && root.contains(tile)) {
        var fs = tile.closest('[data-crl-opt]');
        state.selected[parseInt(fs.getAttribute('data-crl-opt'), 10)] = tile.getAttribute('data-value');
        render();
        if (window.matchMedia('(max-width: 749px)').matches) closeAll();
        return;
      }
      var tog = e.target.closest('[data-crl-toggle]');
      if (tog) {
        var open = tog.getAttribute('aria-expanded') === 'true';
        closeAll();
        tog.setAttribute('aria-expanded', open ? 'false' : 'true');
        tog.closest('[data-crl-opt]').classList.toggle('is-open', !open);
        return;
      }
      var plan = e.target.closest('[data-crl-plan]');
      if (plan) {
        state.sub = plan.getAttribute('data-crl-plan') === 'sub';
        render();
        return;
      }
      var fb = e.target.closest('[data-plan-id]');
      if (fb) {
        state.plan = fb.getAttribute('data-plan-id');
        state.sub = true;
        render();
        return;
      }
      var q = e.target.closest('[data-crl-qty]');
      if (q) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(q.getAttribute('data-crl-qty'), 10));
        render();
      }
    });
    qtyInput.addEventListener('change', render);

    function closeAll() {
      opts.forEach(function (fs) {
        fs.classList.remove('is-open');
        var t = fs.querySelector('[data-crl-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    // Gallery: thumbnails scroll the track; dots follow the scroll position.
    var track = root.querySelector('[data-crl-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.crl-gal__thumb'));
    var dotsWrap = root.querySelector('[data-crl-dots]');
    if (track) {
      var slides = track.children;
      if (dotsWrap) {
        for (var i = 0; i < slides.length; i++) dotsWrap.appendChild(document.createElement('span'));
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      var onScroll = function () {
        var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
      onScroll();
    }

    // Sticky bar shows once the main add button is off screen.
    if (sticky && 'IntersectionObserver' in window) {
      // Show once the main add button has scrolled away, hide again when the footer comes into view.
      var atcGone = false, footerIn = false;
      var syncSticky = function () {
        var show = atcGone && !footerIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var btn = sticky.querySelector('[data-crl-sticky-btn]');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        atcGone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        syncSticky();
      }).observe(atc);
      var footer = document.querySelector('.shopify-section-group-footer-group, footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerIn = entries[0].isIntersecting;
          syncSticky();
        }).observe(footer);
      }
      sticky.querySelector('[data-crl-sticky-btn]').addEventListener('click', function () { atc.click(); });
    }

    // Bundle progress from the cart.
    var bundle = root.querySelector('[data-crl-bundle]');
    function refreshBundle() {
      if (!bundle) return;
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(r + 'cart.js').then(function (res) { return res.json(); }).then(function (cart) {
        var n = cart.item_count || 0;
        var tiers = [[4, 5], [7, 8], [10, 10], [15, 12]];
        var segs = bundle.querySelectorAll('.crl-pbundle__track span');
        tiers.forEach(function (t, i) { if (segs[i]) segs[i].classList.toggle('is-on', n >= t[0]); });
        var next = tiers.filter(function (t) { return n < t[0]; })[0];
        var msg = bundle.querySelector('[data-crl-bundle-msg]');
        if (!msg) return;
        if (n === 0) msg.textContent = 'Mix any 4 bags, save 5%';
        else if (next) msg.textContent = n + ' in your cart. Add ' + (next[0] - n) + ' more to save ' + next[1] + '%';
        else msg.textContent = 'Top bundle saving unlocked: 12%';
      }).catch(function () {});
    }
    refreshBundle();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshBundle);
    } catch (e) {}

    render();
    // Mobile: size is the key choice, so it starts open.
    var sizeOpt = root.querySelector('.crl-opt--size');
    if (sizeOpt && window.matchMedia('(max-width: 749px)').matches) {
      sizeOpt.classList.add('is-open');
      var st = sizeOpt.querySelector('[data-crl-toggle]');
      if (st) st.setAttribute('aria-expanded', 'true');
    }
    // Always open on the first slide (the selected bag), even if the browser restores a scroll position.
    if (track) {
      track.scrollLeft = 0;
      window.addEventListener('load', function () { track.scrollLeft = 0; });
    }
  }

  function boot() {
    var root = document.querySelector('[data-crl-pdp]');
    if (root) init(root);
    // Origin dialog (details section).
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-crl-origin-open]');
      var d = document.getElementById('crl-origin-dialog');
      if (o && d && d.showModal) { d.showModal(); return; }
      if (e.target.closest('[data-crl-origin-close]') && d) { d.close(); return; }
      if (d && e.target === d) d.close();
      var y = e.target.closest('[data-crl-to-yotpo]');
      if (y) {
        var w = document.querySelector('.yotpo-reviews-main-widget, .yotpo-main-widget, .yotpo-widget-instance[data-yotpo-widget-type="ReviewsMainWidget"], [class*="yotpo-reviews"]');
        if (w) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
